// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DesktopNotAllowedRouteModal {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: var(--base_color2);
  z-index: 999;
  display: flex;
  justify-content: center;
  align-items: center;
}
.DesktopNotAllowedRouteModal .DesktopNotAllowedRouteModal-content {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: var(--spacing_6);
  max-width: 800px;
  text-align: center;
}
.DesktopNotAllowedRouteModal .DesktopNotAllowedRouteModal-body {
  display: flex;
  flex-direction: column;
  gap: var(--spacing_4);
}
.DesktopNotAllowedRouteModal .DesktopNotAllowedRouteModal-body .DesktopNotAllowedRouteModal-title {
  font-size: 1.5rem;
  font-weight: 600;
}
.DesktopNotAllowedRouteModal .DesktopNotAllowedRouteModal-body .DesktopNotAllowedRouteModal-description {
  font-size: 0.875rem;
  white-space: pre-wrap;
}
.DesktopNotAllowedRouteModal .DesktopNotAllowedRouteModal-divider {
  position: relative;
  width: 100%;
}
.DesktopNotAllowedRouteModal .DesktopNotAllowedRouteModal-divider > div {
  width: -webkit-fit-content;
  width: -moz-fit-content;
  width: fit-content;
  font-size: 1.5rem;
  color: var(--color_neutral_500);
  background: var(--color_neutral_0);
  padding: 0 var(--spacing_3);
  position: relative;
  margin: 0 auto;
  z-index: 1;
}
.DesktopNotAllowedRouteModal .DesktopNotAllowedRouteModal-divider::before {
  content: "";
  position: absolute;
  top: 50%;
  left: 0;
  right: 0;
  height: 1px;
  background-color: var(--color_neutral_500);
}`, "",{"version":3,"sources":["webpack://./src/components/DesktopNotAllowedRouteModal/index.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,8BAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AACF;AACE;EACE,SAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,qBAAA;EACA,gBAAA;EACA,kBAAA;AACJ;AAEE;EACE,aAAA;EACA,sBAAA;EACA,qBAAA;AAAJ;AAEI;EACE,iBAAA;EACA,gBAAA;AAAN;AAGI;EACE,mBAAA;EACA,qBAAA;AADN;AAKE;EACE,kBAAA;EACA,WAAA;AAHJ;AAKI;EACE,0BAAA;EAAA,uBAAA;EAAA,kBAAA;EACA,iBAAA;EACA,+BAAA;EACA,kCAAA;EACA,2BAAA;EACA,kBAAA;EACA,cAAA;EACA,UAAA;AAHN;AAMI;EACE,WAAA;EACA,kBAAA;EACA,QAAA;EACA,OAAA;EACA,QAAA;EACA,WAAA;EACA,0CAAA;AAJN","sourcesContent":[".DesktopNotAllowedRouteModal {\n  position: fixed;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  background: var(--base_color2);\n  z-index: 999;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n\n  .DesktopNotAllowedRouteModal-content {\n    flex: 1;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    gap: var(--spacing_6);\n    max-width: 800px;\n    text-align: center;\n  }\n\n  .DesktopNotAllowedRouteModal-body {\n    display: flex;\n    flex-direction: column;\n    gap: var(--spacing_4);\n\n    .DesktopNotAllowedRouteModal-title {\n      font-size: 1.5rem;\n      font-weight: 600;\n    }\n\n    .DesktopNotAllowedRouteModal-description {\n      font-size: 0.875rem;\n      white-space: pre-wrap;\n    }\n  }\n\n  .DesktopNotAllowedRouteModal-divider {\n    position: relative;\n    width: 100%;\n\n    & > div {\n      width: fit-content;\n      font-size: 1.5rem;\n      color: var(--color_neutral_500);\n      background: var(--color_neutral_0);\n      padding: 0 var(--spacing_3);\n      position: relative;\n      margin: 0 auto;\n      z-index: 1;\n    }\n\n    &::before {\n      content: '';\n      position: absolute;\n      top: 50%;\n      left: 0;\n      right: 0;\n      height: 1px;\n      background-color: var(--color_neutral_500);\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
